import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getWonderColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "Windpark-ID", accessorKey: "parameters.wonderId" },
    { header: "Name", accessorKey: "parameters.name" },
    { header: "Hersteller", accessorKey: "parameters.manufacturer" },
    { header: "Seriennummer", accessorKey: "parameters.serialNumber" },
    { header: "Typ", accessorKey: "parameters.type" },
    { header: "Nennleistung", accessorKey: "parameters.nominalPower" }
  ];
}

export { getWonderColumns };
